var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgsprites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.9 32",
    id: "apple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.31 24.91A17.13 17.13 0 0124.6 28a15.71 15.71 0 01-2.22 2.68A4.4 4.4 0 0119.54 32a7.3 7.3 0 01-2.62-.63 7.62 7.62 0 00-2.83-.64 7.74 7.74 0 00-2.9.64 8.76 8.76 0 01-2.5.67 4.1 4.1 0 01-2.91-1.29A16.93 16.93 0 013.47 28 19.3 19.3 0 011 23.08a17.73 17.73 0 01-1-5.81 10.55 10.55 0 011.38-5.54 8 8 0 016.85-4.05 9.27 9.27 0 013 .71 9.8 9.8 0 002.41.71 14.94 14.94 0 002.68-.83A9.07 9.07 0 0120 7.62a7.76 7.76 0 016.06 3.2 6.73 6.73 0 00-3.58 6.12A6.83 6.83 0 0024.69 22a7.79 7.79 0 002.21 1.46c-.21.47-.39 1-.59 1.42zM20.13.63a6.85 6.85 0 01-1.75 4.48 6 6 0 01-5 2.45 5.86 5.86 0 010-.61 7 7 0 011.86-4.52 7.26 7.26 0 012.25-1.7A6.62 6.62 0 0120.07 0a2.32 2.32 0 01.06.63z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 33.33",
    id: "arrow-down-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 30.2V0m11 17l-11 13.2L1.55 17",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.33 25",
    id: "arrow-left-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.33 12.5H3.17m13.16 11l-13.16-11L16.33 1.55",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.33 25",
    id: "arrow-right-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.16 12.5H0M17 1.55l13.16 11L17 23.45",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 33.33",
    id: "arrow-up-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 33.33V3.17M1.55 16.33l11-13.16 11 13.16",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "arrow-up-right-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M14.67 13.67V1.45M15.67 1.45H2.44M14.67 1.45L1.33 14.78"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    id: "attachment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.43 11l-1 1-4.81 4.84a4.57 4.57 0 01-6.46-6.46l7.75-7.75a2.74 2.74 0 113.87 3.88l-7.1 7.1a.92.92 0 01-1.29 0 .94.94 0 010-1.3l3.88-3.87.32-.32 1-1a.92.92 0 00-1.3-1.29l-1 1-.29.32L5.1 11A2.74 2.74 0 009 14.9l7.1-7.1a4.57 4.57 0 00-6.48-6.46L8.33 2.63 1.87 9.09a6.39 6.39 0 009 9l4.85-4.85 1-1a.92.92 0 000-1.3.91.91 0 00-1.29.06z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 13",
    id: "behance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76 5.41A3.52 3.52 0 005.78 0H.45A.45.45 0 000 .46v11.82a.45.45 0 00.45.46h6a4 4 0 002.31-7.33zM2.34 2.36h3.49a1.16 1.16 0 010 2.31H2.34zm4.12 8H2.34V7h4.12a1.68 1.68 0 010 3.35zm14.23-2.5a4.9 4.9 0 00-4.79-5 4.9 4.9 0 00-4.79 5 4.91 4.91 0 004.79 5 4.75 4.75 0 004-2.23 4.68 4.68 0 00.3-.54.21.21 0 00-.2-.27h-2.35a.25.25 0 00-.14.06 2.22 2.22 0 01-1.61.65 2.52 2.52 0 01-2.4-2.07h6.72a.47.47 0 00.47-.46zM15.9 5.25a2.4 2.4 0 012 1.19h-4.1a2.4 2.4 0 012.1-1.19zm2-2.95h-4.26a.37.37 0 01-.36-.37V.86a.36.36 0 01.36-.36h4.25a.36.36 0 01.36.36v1.07a.37.37 0 01-.36.37z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30",
    id: "chat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26c8.84 0 16-5.82 16-13S24.84 0 16 0 0 5.82 0 13a11.72 11.72 0 004.12 8.71L3.33 30l7.53-4.69A19.11 19.11 0 0016 26z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 24",
    id: "check-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M1.45 11.85l9.28 9.25L30.55 1.5"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 19.28",
    id: "chevron-down-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M1.5 1.4l14.63 15 14.37-15"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.28 32",
    id: "chevron-left-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M17.88 1.5l-15 14.37 15 14.63"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.28 32",
    id: "chevron-right-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M1.4 30.5l15-14.63L1.4 1.5"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 19.28",
    id: "chevron-up-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M30.5 17.88l-14.37-15-14.63 15"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "dribbble"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0a16 16 0 1016 16A16 16 0 0016 0zm10.43 7.55a13.38 13.38 0 013 8 22.6 22.6 0 00-9-.09c-.48-1.12-1-2.2-1.48-3.21a26.68 26.68 0 007.48-4.7zm-1.81-1.84A23.78 23.78 0 0117.75 10a62.59 62.59 0 00-4.55-7.14 13.57 13.57 0 012.8-.29 13.35 13.35 0 018.62 3.14zm-14-2a60.23 60.23 0 014.68 7.22 42.76 42.76 0 01-12.36 1.94 13.5 13.5 0 017.67-9.17zm-8 11.75h.08a46.59 46.59 0 008.14-.75 39.89 39.89 0 005.7-1.47c.47.92.93 1.9 1.38 2.93a24 24 0 00-6.28 3.11 28.44 28.44 0 00-5.84 5.4A13.35 13.35 0 012.57 16c0-.18.01-.37.01-.55zm5 11a25.86 25.86 0 015.52-5.13 21.88 21.88 0 015.72-2.82 49.37 49.37 0 012.7 9.7A13.21 13.21 0 0116 29.43a13.35 13.35 0 01-8.39-2.96zm16.31.37a53.48 53.48 0 00-2.53-8.92 20.31 20.31 0 017.86.26 13.46 13.46 0 01-5.34 8.67z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.76 32",
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.71 5.33h3.05V.15C16.3.15 14.48 0 12.34 0 7.92 0 5 2.59 5 7.47v4.26H0v5.64h5V32h6V17.37h4.88l.76-5.64h-5.82V8.08c0-1.68.46-2.75 2.89-2.75z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "github"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.05 0A16.22 16.22 0 000 16.43 16.38 16.38 0 0011 32c.86.11 1.07-.33 1.07-.76v-2.87c-4.49 1-5.45-2.19-5.45-2.19a4.63 4.63 0 00-1.82-2.41c-1.5-1 .1-1 .1-1a3.37 3.37 0 012.46 1.65c1.4 2.51 3.75 1.75 4.71 1.31a3.05 3.05 0 011.07-2.19c-3.53-.44-7.27-1.86-7.27-8.11a6.64 6.64 0 011.6-4.38 5.84 5.84 0 01.13-4.37S9 6.24 12 8.32a16.92 16.92 0 014.06-.54 17 17 0 014.07.54c3.1-2.08 4.39-1.64 4.39-1.64a5.82 5.82 0 01.1 4.38 6.13 6.13 0 011.61 4.38c0 6.36-3.75 7.67-7.28 8.11A4.25 4.25 0 0120 26.62v4.49a.77.77 0 001.07.76A16.29 16.29 0 0032 16.32 16 16 0 0016.05 0z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 32",
    id: "google-play"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 31.55l13.88-14 4.9 4.94L3 31.74a2 2 0 01-2 0zm12.48-15.41L0 29.49V2.79zm8.27-5.52l6.5 3.63a2 2 0 010 3.5l-6.64 3.73L16 16.14zM.61.58A1.78 1.78 0 011 .27a2 2 0 012 0l16.7 9.34-5.07 5.12z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14",
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14l-1.45-1.45a40.38 40.38 0 01-4.18-4.06A6.41 6.41 0 01.15 4.4 4.35 4.35 0 014.54 0a4.67 4.67 0 013 1.08 4.67 4.67 0 013-1.08 4.35 4.35 0 014.39 4.4 6.41 6.41 0 01-1.72 4.09A40.38 40.38 0 019 12.55zm-3-12.45A2.78 2.78 0 001.7 4.4c0 2.11 2 3.94 5.39 7l.39.4.39-.4c3.44-3.06 5.39-4.89 5.39-7a2.78 2.78 0 00-2.84-2.85 3.21 3.21 0 00-2.33 1.11l-.59.7-.59-.7a3.21 3.21 0 00-2.37-1.11z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30.84",
    id: "heart-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14.83l-12 14-12-14A8.44 8.44 0 014 4.2 6 6 0 018.54 2a6 6 0 014.55 2.2L15 6.4a1.34 1.34 0 002 0l1.89-2.2a5.82 5.82 0 019.11 0 8.44 8.44 0 010 10.63z",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    id: "help"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.15 29.31a14.16 14.16 0 1114.16-14.16 14.17 14.17 0 01-14.16 14.16zm0-27.53a13.38 13.38 0 1013.38 13.37A13.39 13.39 0 0015.15 1.78zm-1 15.32h1v-.7c0-.57.63-1.06 1.24-1.66a3.52 3.52 0 001.26-2.52A2.58 2.58 0 0015 9.6a3.32 3.32 0 00-2.69 1.3l.85.8a2.15 2.15 0 011.75-1 1.48 1.48 0 011.57 1.54 3 3 0 01-1 2c-.62.66-1.28 1.25-1.26 2.12zm.53 3a.83.83 0 00.83-.83.82.82 0 00-.83-.82.83.83 0 00-.84.82.84.84 0 00.89.83z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "instagram"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 10v12a7.07 7.07 0 007 7h12a7.07 7.07 0 007-7V10a7.07 7.07 0 00-7-7H10a7.07 7.07 0 00-7 7zm-3 0A9.81 9.81 0 0110 0h12a9.81 9.81 0 0110 10v12a9.81 9.81 0 01-10 10H10A9.81 9.81 0 010 22zm16 10.71A4.71 4.71 0 1011.29 16 4.66 4.66 0 0016 20.71zm0 2.82A7.53 7.53 0 1123.53 16 7.55 7.55 0 0116 23.53zm9.41-15.06a1.88 1.88 0 01-3.76 0 1.88 1.88 0 113.76 0z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30.48",
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 18.72v11.76h-7V19.59c0-2.83-1-4.59-3.45-4.59a3.1 3.1 0 00-3.26 2.39 3.24 3.24 0 00-.22 1.53v11.56h-7V10h7v2.83a7 7 0 016.09-3.48c4.57.01 7.84 3.06 7.84 9.37zM3.92 0C1.52 0 0 1.52 0 3.48A3.5 3.5 0 003.7 7c2.4 0 3.92-1.56 3.92-3.52A3.37 3.37 0 003.92 0zM.44 30.48h7V10h-7z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 20",
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32 16.46a4 4 0 01-3.85-4.14 4 4 0 013.85-4.14 3.78 3.78 0 013.28 2l2.54-1.68A6.75 6.75 0 007.33 5 7.14 7.14 0 00.5 12.33a7.13 7.13 0 006.83 7.34 6.74 6.74 0 005.74-3.35l-2.5-1.73a3.87 3.87 0 01-3.25 1.87zm16.8-2.79a2.81 2.81 0 01-2.83 2.79H21a2.81 2.81 0 01-2.83-2.79v-8.4h-3.38v8.52a5.93 5.93 0 006 5.87h.73a5.93 5.93 0 006-5.87V5.28h-3.39v8.39zm39.12-8.39h-3.05v14h3.05v-6.37c0-3.32 2-4.62 4.49-4.62v-3a8 8 0 00-4.49 1.3zM79.6 18.79a6.44 6.44 0 01-3.13.82 7.14 7.14 0 01-6.83-7.29V.33h3v5h5.24v3h-5.19v4a4 4 0 003.78 4.09 3.47 3.47 0 001.47-.32zm7-13.87a7.12 7.12 0 00-6.86 7.35 6.88 6.88 0 1013.72 0 7.12 7.12 0 00-6.82-7.35zm0 11.49a4 4 0 01-3.87-4.14 3.87 3.87 0 117.73 0 4 4 0 01-3.82 4.14zM36.48 4.92a6.5 6.5 0 00-3.81 1.24V.33h-3.05v12a7.12 7.12 0 006.86 7.35 7.12 7.12 0 006.87-7.35 7.13 7.13 0 00-6.87-7.41zm0 11.49a4 4 0 01-3.87-4.14 3.87 3.87 0 117.73 0 4 4 0 01-3.86 4.14zm21.91-2.9a8.32 8.32 0 00.09-1.24 8.66 8.66 0 00-.09-1.27 7 7 0 00-6.76-6.1 7.12 7.12 0 00-6.86 7.35 7.12 7.12 0 006.86 7.35 6.77 6.77 0 005.73-3.31l-2.49-1.76a3.8 3.8 0 01-3.23 1.86 3.92 3.92 0 01-3.69-2.9zm-6.76-5.39A3.92 3.92 0 0155.32 11H48a3.89 3.89 0 013.63-2.88z",
    fill: "currentColor"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 32",
    id: "long-arrow-down-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.67 26.28L6 31.33l-5.67-5M6 0v31.32",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 12",
    id: "long-arrow-left-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67 11.67L.67 6 5.72.33M.68 6H32",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 12",
    id: "long-arrow-right-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.28.33l5 5.67-5 5.67M0 6h31.32",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 32",
    id: "long-arrow-up-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.33 5.67L6 .67l5.67 5.05M6 .68V32",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73 16",
    id: "medium"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.87 14c0 .26 0 .32.17.49l1 1h-4.29v-1.88a2.94 2.94 0 01-2.81 2.05c-2.19 0-3.77-1.8-3.77-5.11 0-3.1 1.71-5.17 4.11-5.17A2.5 2.5 0 0133.75 7V2.82a.55.55 0 00-.2-.51l-.91-.92 4.23-.56zm-3.12-.6V7.17a1.58 1.58 0 00-1.26-.63c-1 0-2 1-2 3.91 0 2.74.86 3.7 1.93 3.7a1.67 1.67 0 001.33-.76zm5.94 2.11V7.1a.6.6 0 00-.17-.5l-1-1h4.25v8.52c0 .26 0 .32.17.48l.94.93zm-.16-13a1.71 1.71 0 113.42 0 1.71 1.71 0 11-3.42 0zM54.28 14c0 .27 0 .34.17.51l1 1h-4.31v-2.16a3.11 3.11 0 01-2.93 2.31c-1.89 0-2.9-1.45-2.9-4.2V7.05a.52.52 0 00-.18-.48l-.94-1h4.22V11c0 1.8.25 3 1.32 3a1.69 1.69 0 001.38-.9v-6a.63.63 0 00-.11-.5l-.95-1h4.25zm14.45 1.5c0-.32.06-4.45.06-5.4 0-1.8-.27-3-1.47-3a1.88 1.88 0 00-1.51.86A7.58 7.58 0 0166 9.63c0 1.25 0 2.84-.06 4.43a.56.56 0 00.17.49l1 .92h-4.35c0-.3.06-4.45.06-5.4 0-1.83-.27-3-1.45-3A1.71 1.71 0 0060 8v6.12c0 .26 0 .32.17.49l.94.92h-4.29v-8.4a.57.57 0 00-.17-.5l-.94-1H60v2.04a3.07 3.07 0 013-2.3 2.76 2.76 0 012.77 2.4A3.33 3.33 0 0169 5.37c1.9 0 3 1.47 3 4.25 0 1.33 0 2.84-.06 4.43a.49.49 0 00.2.49l.93.92zm-53.34-1.31l1.26 1.27h-6.39l1.28-1.27a.51.51 0 00.17-.48v-8.1a8.45 8.45 0 01.06-1.2L7.46 15.66 3 5.31c-.1-.25-.13-.27-.19-.45v6.79A2.55 2.55 0 003 13l1.79 2.48H0L1.8 13a2.59 2.59 0 00.2-1.35v-7.5a1.51 1.51 0 00-.3-1L.44 1.39H5l3.82 8.76 3.36-8.76h4.46l-1.25 1.47a.54.54 0 00-.2.5v10.35a.49.49 0 00.2.48zm5-4c0 2.57 1.26 3.6 2.73 3.6A3.09 3.09 0 0026 11.93c-.51 2.53-2 3.73-4.24 3.73-2.41 0-4.69-1.53-4.69-5.07 0-3.73 2.28-5.22 4.8-5.22a3.86 3.86 0 014.19 4.25v.52zm0-.52h2.81V9.1c0-2.64-.52-3.34-1.3-3.34-.95 0-1.52 1-1.52 3.86z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16",
    id: "patreon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.89,
    cy: 6.11,
    r: 6.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.66v15.94H0z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    id: "play-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.15.39A13.77 13.77 0 11.39 14.15 13.76 13.76 0 0114.15.39zM12 10.82l5.78 3.34L12 17.49z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.78
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 22",
    id: "play-o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 17.837V4.163c0-1.85 2.002-3.004 3.602-2.077l11.81 6.837c1.597.924 1.597 3.23 0 4.154l-11.81 6.837C3.002 20.841 1 19.686 1 17.837z",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 791 152",
    id: "runnytimes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.65 33.15A30.81 30.81 0 00173 37.67a25.28 25.28 0 00-10.44 12.53V34.29h-20.21v79.39h20.21V71.55q0-10.45 5.16-16t13.76-5.59q8.46 0 13.33 5.23t4.87 14.69v43.85h20.06v-46.2q0-16.33-8.17-25.37t-21.92-9.01zm90.88 0a30.81 30.81 0 00-16.7 4.52 25.28 25.28 0 00-10.39 12.53V34.29h-20.21v79.39h20.21V71.55q0-10.45 5.16-16t13.76-5.59q8.46 0 13.33 5.23t4.87 14.69v43.85h20.06v-46.2q0-16.33-8.17-25.37t-21.92-9.01zm76 55l-21.65-53.86h-22.5l33.39 77.11-17.91 40.12h22.36L398.8 34.29h-22.21zm108.56-53.86h20.21v79.39h-20.21zm19.2-30.74a14.82 14.82 0 00-18.06 0 10.22 10.22 0 00-3.44 8 10.05 10.05 0 003.44 7.81 14.82 14.82 0 0018.06 0 10.05 10.05 0 003.44-7.81 10.18 10.18 0 00-3.44-8zm117.52 29.6a30 30 0 00-27.66 17.77 28 28 0 00-10.68-13.18 30.07 30.07 0 00-16.7-4.59 29.4 29.4 0 00-15.84 4.23 24.6 24.6 0 00-10 12V34.3h-20.17v79.39H521V71.56q0-10.17 5-15.48t13.47-5.29q8.17 0 12.83 4.94t4.7 14.12v43.84h20V71.56q0-10.17 5-15.48t13.47-5.29q8.18 0 12.83 4.94t4.7 14.12v43.84h20.06V67.54q0-16.49-8.38-25.44t-22.87-8.95zm185 45.79a24.25 24.25 0 00-9.75-7 102.3 102.3 0 00-14.69-4.23q-6.45-1.57-9.89-2.71a16.36 16.36 0 01-5.73-3.16 6.68 6.68 0 01-2.29-5.3 8.18 8.18 0 012.87-6.59c1.91-1.62 4.59-2.44 8-2.44q6.45 0 10.46 3.44A15.78 15.78 0 01771 60.1h18.91A31.67 31.67 0 00779 40.61q-8.75-7.3-23.22-7.31-13.9 0-21.78 6.45a20.63 20.63 0 00-7.88 16.77q0 8 3.94 12.61a22.83 22.83 0 009.46 6.66 112 112 0 0014.4 4.09c4.3 1.05 7.62 2 10 2.72a16 16 0 015.88 3.3 7.19 7.19 0 012.36 5.59A8.46 8.46 0 01769.4 98c-1.82 1.67-4.44 2.51-7.88 2.51q-7.17 0-11.61-3.37a13.05 13.05 0 01-5.15-9.23h-19.35q2 12.89 11.32 19.84t24.79 6.95q13.47 0 21.42-6.31a20 20 0 007.95-16.47c0-5.46-1.36-9.78-4.08-12.98zm-360-72.39h-19.27V73c.17 22.45 18.21 40.71 40.2 40.71.82 0 1.63 0 2.45-.09V94.39a22.07 22.07 0 01-2.45.15c-11.42 0-20.82-9.68-21-21.57V51.7h23.41V34.29h-23.38V6.55zM110.42 80.13c0 8.39-7.39 15.19-16.51 15.19h-2c-9.12 0-16.51-6.8-16.51-15.19V34.3H56v46.45c0 17.7 15.59 32.05 34.83 32.05H95c19.24 0 34.83-14.35 34.83-32V34.3h-19.4v45.83zM18.18 41.44v-7.29H.11v79.68h18.07V77.7c0-22.7 16.33-26.14 26.06-26.16h.14V34.15h-.14a47.94 47.94 0 00-26.06 7.29zm662.76-8.12a36.17 36.17 0 00-19.24 5.18c-26.7 15.74-24.91 57.5 2.65 71.31a36.6 36.6 0 0016.36 3.88A38 38 0 00713 95.29l-14.05-9.53a22.11 22.11 0 01-7.84 7.61 20.83 20.83 0 01-10.36 2.76c-9.7 0-18-6.83-20.72-16.1h58.57a43.16 43.16 0 00.52-6.63 39.35 39.35 0 00-.6-6.9c-3.39-19.12-19.73-32.85-37.58-33.18zm0 33.19h-20.87a.42.42 0 010-.12 22.48 22.48 0 013.93-7.34 21.67 21.67 0 0116.68-8.27h.24a22.16 22.16 0 0120.4 15.73z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28",
    id: "telegram"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.52 13.31L7.9 16.1l2.92 9.2a.87.87 0 001.4.41l4.17-3.34a1.09 1.09 0 011.53 0l7.38 5.43a.85.85 0 001.39-.55L32 1.05a.83.83 0 00-1.11-1L.52 11.64a.93.93 0 000 1.67zm9.75 1.26l14.47-8.92c.28-.14.56.28.28.42l-11.83 11a3.34 3.34 0 00-.84 1.54l-.41 3.06c0 .42-.56.42-.7 0l-1.53-5.43a1.33 1.33 0 01.56-1.67z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "times-o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M1.5 1.5l29 29M1.5 30.5l29-29"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 26",
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8 4.2a7.52 7.52 0 003-3.6 10.77 10.77 0 01-4.2 1.6A7.18 7.18 0 0021.8 0a6.49 6.49 0 00-6.4 6.6 4.4 4.4 0 00.2 1.6 19.64 19.64 0 01-13.4-7 6.64 6.64 0 00-1 3.2 6.65 6.65 0 003 5.6 7.41 7.41 0 01-3-.8 6.85 6.85 0 005.4 6.6H4.8a2.54 2.54 0 01-1.2-.2 6.62 6.62 0 006 4.6 13 13 0 01-8 2.8H0a19 19 0 0010 3c12 0 18.6-10 18.6-18.6v-.8A27.25 27.25 0 0032 3.2a41.87 41.87 0 01-4.2 1z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 18.5",
    id: "vk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.83 16.61c-.88-1.91-2.71-3.26-4.15-4.72-.74-.74-1.15-1.42-.57-2.4a35.72 35.72 0 012.28-3.06 22.25 22.25 0 002.13-3.23c.24-.47.71-1.32.39-1.84C31.43.58 28.78 1 28 1s-2.49-.3-3.18.16c-.47.31-.63 1.14-.84 1.63-.3.68-.63 1.35-1 2a17.53 17.53 0 01-2.19 3.31c-.27.31-.77.93-1.21.92-.71 0-.85-1-.89-1.49a30.29 30.29 0 010-3.69c0-1 .37-2.73-.66-3.34S15 .09 13.83.14a5.28 5.28 0 00-2.64.52c-.14.09-.55.39-.55.57s.23.2.52.3a1.69 1.69 0 011.05.81 7.8 7.8 0 01.41 3.81c0 .72 0 2.51-.8 2.87-1.57.72-3.37-3.71-3.9-4.76-.34-.66-.66-1.32-1-2a2.13 2.13 0 00-.69-1.09 2.58 2.58 0 00-1.5-.24A34.72 34.72 0 00.91 1C-.68 1.16.34 2.67.76 3.58q.94 2 2 4c2.32 4.11 5.24 8.73 9.95 10.27a10.11 10.11 0 003.37.43 5.22 5.22 0 002-.11c1-.44.56-1.9.82-2.75.43-1.43 1.38-1.6 2.43-.61 1.67 1.53 2.67 3.63 5.18 3.54 1.32-.05 2.65 0 4-.06.97-.05 1.85-.55 1.32-1.68z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 15",
    id: "youtube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.22 1.29C18.5.37 17.17 0 14.62 0H5.38C2.78 0 1.42.4.7 1.37S0 3.72 0 5.66v3.69C0 13.1.83 15 5.38 15h9.24c2.21 0 3.43-.33 4.22-1.14S20 11.68 20 9.35V5.66c0-2.05 0-3.45-.78-4.37zM12.84 8l-4.2 2.34a.59.59 0 01-.29.07.67.67 0 01-.35-.08.72.72 0 01-.31-.59V5.08A.72.72 0 018 4.49a.62.62 0 01.63 0l4.2 2.32a.71.71 0 010 1.22z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgsprites);
export default __webpack_public_path__ + "static/media/svgsprites.50fd4665c2f39e1e1679a377aebf1e64.svg";
export { ForwardRef as ReactComponent };